import {
    EuiButton,
    EuiBasicTable,
    EuiFlexGroup,
    EuiFlexItem,
    EuiPanel,
    EuiText,
    EuiSpacer,
} from "@elastic/eui";
import { getDocs, query, where } from "firebase/firestore";
import { useEffect, useState, useCallback } from "react";
import { useAppSelector } from "../app/hooks";
import Header from "../components/Header";
import useAuth from "../hooks/useAuth";
import { meetingsRef, recordingRef } from "../utils/FirebaseConfig";
import { UserRecordingType } from "../utils/types";

export default function UserRecordings() {
    useAuth();
    const userInfo = useAppSelector((happymeet) => happymeet.auth.userInfo);
    const [recordings, setRecordings] = useState<Array<UserRecordingType>>([]);



    const getMyRecordings = useCallback(async () => {
        const firestoreQuery = query(
            recordingRef,
            where("user_id", "==", userInfo?.uid)
        );
        const fetchedRecording = await getDocs(firestoreQuery);




        if (fetchedRecording.docs.length) {
            const myRecordings: Array<UserRecordingType> = await Promise.all(
                fetchedRecording.docs.map(async (doc) => {
                    const data = doc.data();

                    const firestoreQuery = query(
                        meetingsRef,
                        where("meetingId", "==", data.meeting_id)
                    );
                    const fetchedMeeting = await getDocs(firestoreQuery);

                    const meetingData = !fetchedMeeting.empty
                        ? fetchedMeeting.docs[0].data()
                        : { meetingName: "Inconnu", meetingDate: "" };

                    return {
                        meetingName: meetingData.meetingName,
                        meetingDate: meetingData.meetingDate,
                        url: data.url
                    };
                })
            );

            setRecordings(myRecordings);
        }

    }, [userInfo?.uid]);


    useEffect(() => {
        if (userInfo) getMyRecordings();

    }, [userInfo, getMyRecordings]);



    const recordingColumns = [
        {
            field: "meetingName",
            name: "Meeting Name",
        },
        {
            field: "meetingDate",
            name: "Meeting Date",
        },
        {
            field: "url",
            name: "vidéo",
            render: (url: string) => {
                    return (
                      <EuiButton
                        size="s"
                        color="primary"
                        iconType="play"
                        href={url}
                        target="_blank"
                        >
                        Voir la vidéo
                        </EuiButton>
                    );
                  },
        },

    ];
    //console.log("efedcd", recordings);
    return (
        <div
            style={{
                display: "flex",
                height: "100vh",
                flexDirection: "column",
            }}
        >
            <Header />
            <EuiFlexGroup justifyContent="center" style={{ margin: "1rem" }}>
                <EuiFlexItem>
                    <EuiPanel>
                        <EuiText textAlign="center">
                            <h3> Mes enregristrements</h3>
                        </EuiText>
                        <EuiSpacer size="xl" />
                        <EuiBasicTable items={recordings} columns={recordingColumns} />
                    </EuiPanel>
                </EuiFlexItem>
            </EuiFlexGroup>

        </div>
    );
}
